import { AccountBalanceWalletOutlined, BuildOutlined, HandymanOutlined, LockOutlined, Wallet, WalletOutlined } from "@mui/icons-material";
import React from "react";

const FeaturesSection = () => {
  const features = [
    {
      icon: AccountBalanceWalletOutlined, // Replace with your icon (SVG or image path if needed)
      color: "#94bc4e", // Replace with your color
      title: "Instant Savings",
      description:
        "Upgrading to a higher plan provides increased flexibility and storage capacity.",
    },
    {
      icon: LockOutlined,
      title: "Secure Payment",
      color: "#5ebbed",
      description:
        "All payments are securely processed through Stripe under the name AITech Group Corporation.",
    },
    {
      icon: HandymanOutlined,
      title: "No setup or hidden fees",
        color: "#b887e2",
      description:
        "There are no hidden costs, setup, or termination fees attached to our packages. All our plans are clear. We do not charge for any additional services.",
    },
  ];

  return (
    <section className="features-section">
      {features.map((feature, index) => (
        <div key={index} className="feature-item">
          <div className="feature-icon" style={{
            color: feature.color,
          }}><feature.icon style={{
            fontSize: "2rem",
          }}/></div>
          <div className="feature-text">
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        </div>
      ))}
    </section>
  );
};

export default FeaturesSection;
